import type { Hotspot } from '@recruitee/integrations-types';
import { Hotspots } from '@recruitee/integrations-types';
import { stableStringify } from '@recruitee/utils';

const stringifyHotspot = (hotspot: Hotspot): string => {
  const signature = { name: hotspot.name, ...hotspot.params };
  return stableStringify(signature);
};

const pruneHotspotParams = (hotspot: Hotspot): Hotspot => {
  switch (hotspot.name) {
    case Hotspots.CandidateProfileMore: {
      return {
        name: hotspot.name,
        params: { candidateId: hotspot.params.candidateId },
      };
    }
    case Hotspots.CandidateProfileOverview: {
      return {
        name: hotspot.name,
        params: { candidateId: hotspot.params.candidateId },
      };
    }
    case Hotspots.OfferPromoteJobBoards: {
      return {
        name: hotspot.name,
        params: { offerId: hotspot.params.offerId },
      };
    }
    default:
      return hotspot;
  }
};

export const hotspotToSignature = (hotspot: Hotspot): string =>
  stringifyHotspot(pruneHotspotParams(hotspot));

export const getCandidateViewsHotspot = (candidateId: number) =>
  <const>{
    name: Hotspots.CandidatesTableBadges,
    params: { candidateId },
  };
